import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

interface CartState {
  items: any[];
  cartQuantity: number;
}

const initialState: CartState = {
  items: [],
  cartQuantity: 0,
};

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action: PayloadAction<any>) => {
      state.items.push(action.payload);
    },
    updateCartQuantity: (state, action: PayloadAction<number>) => {
      state.cartQuantity = action.payload;
    },
  },
});

export const { updateCartQuantity } = cartSlice.actions;

export const { addToCart } = cartSlice.actions;

export const selectItems = (state: RootState) => state.cart.items;

export default cartSlice.reducer;